import { useState, useEffect } from 'react';

/**
 * Vrai à partir du breakpoint `md` (768px), là où la barre latérale desktop
 * est visible (cf. DashboardLayout : Sidebar en `hidden md:block`).
 *
 * Sert aux hubs thématiques : la navigation par onglets est pensée pour le
 * mobile. Sur desktop, la barre latérale liste déjà chaque page (Événements,
 * Lectures collectives…) — on masque donc les onglets qui y font doublon.
 */
const QUERY = '(min-width: 768px)';

export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(QUERY).matches
      : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsDesktop(e.matches);
    setIsDesktop(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
